import { useTypedParams } from '@sorare/routing';
import { useIntlContext } from '@sorare/core/src/contexts/intl';

import { Post } from '#src/components/Post/index.tsx';
import type { BlogSport } from '#src/constants/types.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const PostPage = () => {
  const { slug, sport } = useTypedParams<PageParams>();
  const { language } = useIntlContext();

  return (
    <Post sportCategory={sport as BlogSport} slug={slug} language={language} />
  );
};

export default PostPage;
